"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConfirmationSmsCodeForm = require("./ConfirmationSmsCodeForm");
Object.keys(_ConfirmationSmsCodeForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfirmationSmsCodeForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfirmationSmsCodeForm[key];
    }
  });
});